import {
  FETCH_PAYMENT_DATA_FAILURE,
  FETCH_PAYMENT_DATA_REQUEST,
  FETCH_PAYMENT_DATA_SUCCESS,
} from '@/actionTypes';

import createReducer from './createReducer';

const initialState = {
  isFetching: false,
  isRequestFailed: false,
  errorMessage: null,
  originalErrorMessage: null,
  project: null,
};

const payment = createReducer(initialState, {
  [FETCH_PAYMENT_DATA_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),
  [FETCH_PAYMENT_DATA_SUCCESS]: (state, { payload }) => ({
    ...state,
    ...payload,
    isFetching: false,
  }),
  [FETCH_PAYMENT_DATA_FAILURE]: (state, { payload }) => ({
    ...state,
    ...payload,
    isFetching: false,
    isRequestFailed: true,
  }),
});

export default payment;
